export const translations = {
  id: {
    pt: "Id",
    en: "Id",
    de: "id",
    es: "Id",
  },
  codigo: {
    pt: "Código",
    en: "Code",
    de: "Code",
    es: "Código",
  },
  limparFiltro: {
    pt: "Limpar Filtro",
    en: "Clear Filter",
    de: "Filter zurücksetzen",
    es: "Filtro claro",
  },
  fechar: {
    pt: "Fechar",
    en: "Close",
    de: "Schließen",
    es: "Cerrar",
  },
  filtrar: {
    pt: "Filtrar",
    en: "Filter",
    de: "Filtern",
    es: "Filtrar",
  },
  nomeFantasia: {
    pt: "Nome Fantasia",
    en: "Fantasy name",
    de: "Fantasiename",
    es: "Nombre de fantasía",
  },
  cnpj: {
    pt: "CNPJ",
    en: "CNPJ",
    de: "CNPJ",
    es: "Numero de Identificacion",
  },
  tipos: {
    pt: "Tipos",
    en: "Types",
    de: "Typen",
    es: "Tipos",
  },
  selecione: {
    pt: "Selecione...",
    en: "Select...",
    de: "Wählen Sie...",
    es: "Seleccione...",
  },
  ativo: {
    pt: "Ativo",
    en: "Active",
    de: "Aktiv",
    es: "Activo",
  },
  sim: {
    pt: "Sim",
    en: "Yes",
    de: "Ja",
    es: "Sí",
  },
  nao: {
    pt: "Não",
    en: "No",
    de: "Nein",
    es: "No",
  },
};
